import styled from 'styled-components';

const getFontSize = (size = 'm') => {
  switch (size) {
    case 'xs':
      return ['1.6rem', '1.6rem'];
    case 's':
      return ['1.6rem', '1.6rem'];
    case 'm':
      return ['1.8rem', '1.8rem'];
    default:
      return ['1.6rem', '1.6rem'];
  }
};

const Text = styled.p`
  font-size: ${({ size }) => getFontSize(size)[0]};
  color: ${({ theme, color }) => (color ? theme[color] : theme.textColor)};
  font-weight: ${({ weight }) => (weight ? weight : 'normal')};

  @media (${({ theme }) => theme.respondTo.desktop}) {
    font-size: ${({ size }) => getFontSize(size)[0]};
  }
`;

export default Text;
